import { render, staticRenderFns } from "./JournalistsList.vue?vue&type=template&id=44ca0835&"
import script from "./JournalistsList.vue?vue&type=script&lang=js&"
export * from "./JournalistsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports